import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import '../../style.scss';
import { getRegion } from 'utils/Region';
import { getTranslation } from 'utils/getTranslation';

const ErrorMessageKid = ({ isNotFoundContentForKids, code, value }) => {
  const texts = useSelector(state => state.metadata.translations);
  const parseTranslation = JSON.parse(texts).language[getRegion()];

  const notFoundKidTextTitle = getTranslation(
    'kids_withoutResults_alert_title_label',
    parseTranslation,
  );
  const notFoundKidTextDescription = getTranslation(
    'kids_withoutResults_alert_description_label',
    parseTranslation,
  );
  const textPopular = getTranslation(
    'popularSearches_default_title_label',
    parseTranslation,
  );
  const titleLabel = getTranslation(
    'withoutResults_alert_title_label',
    parseTranslation,
  );
  const descriptionLabel = getTranslation(
    'withoutResults_alert_description_label',
    parseTranslation,
  );

  return (
    <Fragment>
      {isNotFoundContentForKids === true && (
        <Fragment>
          <div className="not-found-search-results">
            <p className="not-found-search-results__text">
              <strong className='not-found-search-results__label'>
                {code === 'BYR_PAR_00006'
                  ? `${titleLabel} ${value}`
                  : notFoundKidTextTitle}{' '}
                |{' '}
              </strong>
              <span>
                {code === 'BYR_PAR_00006'
                  ? descriptionLabel
                  : notFoundKidTextDescription}
              </span>
            </p>
          </div>
          <h2 className="search-results__title not-found">{textPopular}</h2>
        </Fragment>
      )}
    </Fragment>
  );
};

export default ErrorMessageKid;
